import {getCookie} from '@/features/organization-team-plan/utils/collect-marketo-tracking';

const TRACKING_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_method',
    'utm_region',
    'utm_segment',
    'utm_type',
    'ref',
    'user_type',
];
const COOKIE_NAME = 'landing-query-params';
const COOKIE_MAX_AGE = 30 * 24 * 60 * 60; // 30 days

export function syncUtmWithCookie(): void {
    const searchParams = new URLSearchParams(window.location.search);
    const hasTrackingParams = TRACKING_KEYS.some((key) => searchParams.has(key));

    if (hasTrackingParams) {
        const isUdemyDomain =
            window.location.hostname === 'udemy.com' ||
            window.location.hostname.endsWith('.udemy.com');
        const domainAttr = isUdemyDomain ? '; domain=.udemy.com' : '';
        // This will override the existing cookies and the utm params if they are existing.
        document.cookie = `${COOKIE_NAME}=${encodeURIComponent(window.location.search)}; max-age=${COOKIE_MAX_AGE}${domainAttr}; path=/; Secure; SameSite=Lax`;
        return;
    }

    const cookieValue = getCookie(COOKIE_NAME);
    if (!cookieValue) return;

    const cookieParams = new URLSearchParams(cookieValue);
    const hasTrackingInCookie = TRACKING_KEYS.some((key) => cookieParams.has(key));
    if (!hasTrackingInCookie) return;

    // merged starts from the current URL, which has no tracking keys at this point
    // (guaranteed by the hasTrackingParams early return above). The !merged.has(key)
    // guard is defensive in case that early-return logic ever changes.
    const merged = new URLSearchParams(window.location.search);
    for (const key of TRACKING_KEYS) {
        const value = cookieParams.get(key);
        if (value && !merged.has(key)) {
            merged.set(key, value);
        }
    }

    const newSearch = merged.toString() ? `?${merged.toString()}` : '';
    history.replaceState(null, '', `${window.location.pathname}${newSearch}${window.location.hash}`);
}
